export const storeUrls = {
    apple: 'https://apps.apple.com/app/mentemia/id1462692772?mt=8',
    google: 'https://play.google.com/store/apps/details?id=com.mentemia.companionapp',
};
